import {
  Glass,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

export function TodayScreen() {
  const trackers = [
    {
      color: "var(--color-kin-gold)", // Kin Gold
      label: "Diet",
      detail: "Meal log",
      status: { kind: "meta", text: "3 meals", color: "var(--color-kin-green-soft)" },
    },
    {
      color: "var(--color-kin-lavender)", // Kin Lavender
      label: "Mood",
      detail: "Daily check-in",
      status: { kind: "action", text: "Log" },
    },
    {
      color: "var(--color-kin-rose)", // Kin Rose
      label: "Headache",
      detail: "Symptom log",
      status: { kind: "meta", text: "1 episode", color: "var(--color-kin-rose)" },
    },
  ];

  const quickActions = [
    {
      label: "Upload",
      icon: (c) => (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke={c}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 15V5" />
          <path d="M8.5 8.5 12 5l3.5 3.5" />
          <path d="M4 15.5v2A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5v-2" />
        </svg>
      ),
    },
    {
      label: "Scan",
      icon: (c) => (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke={c}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 4H5.5A1.5 1.5 0 0 0 4 5.5V7" />
          <path d="M17 4h1.5A1.5 1.5 0 0 1 20 5.5V7" />
          <path d="M20 17v1.5A1.5 1.5 0 0 1 18.5 20H17" />
          <path d="M7 20H5.5A1.5 1.5 0 0 1 4 18.5V17" />
          <path d="M8 12h8" />
        </svg>
      ),
    },
    {
      label: "Note",
      icon: (c) => (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke={c}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 4h10a1.5 1.5 0 0 1 1.5 1.5v13L15 16H7a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 7 4z" />
          <path d="M9 9h6" />
          <path d="M9 12h4" />
        </svg>
      ),
    },
  ];

  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Greeting */}
      <div style={{ display: "flex", flexDirection: "column", gap: 2, paddingLeft: 4 }}>
        <ScreenLabel style={{ letterSpacing: "0.25em", color: "var(--color-kin-muted)" }}>
          Sun, Mar 2
        </ScreenLabel>
        <DisplayText size={28} color="var(--color-kin-black)" lineHeight={1.1}>
          Good morning,
        </DisplayText>
        <DisplayText size={28} color="#3A4A3D" style={{ fontStyle: "italic" }}>
          Sverre
        </DisplayText>
      </div>

      {/* Featured Insight - Luminous Aura */}
      <div style={{ position: "relative" }}>
        {/* Aura Glow */}
        <div
          style={{
            position: "absolute",
            inset: -4,
            background:
              "radial-gradient(circle at 100% 0%, rgba(165,144,255,0.4), transparent 60%)",
            filter: "blur(12px)",
            borderRadius: 24,
            zIndex: 0,
          }}
        />
        <Glass
          style={{
            position: "relative",
            zIndex: 1,
            padding: "14px 16px",
            background:
              "linear-gradient(150deg, rgba(254,253,251,0.7) 0%, rgba(254,253,251,0.4) 100%)",
            border: "1px solid rgba(255,255,255,0.6)",
            boxShadow: "0 8px 24px -8px rgba(165,144,255,0.2), inset 0 1px 0 rgba(255,255,255,0.8)",
            borderRadius: 20,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
            <Dot
              color="var(--color-kin-lavender)"
              size={6}
              style={{ boxShadow: "0 0 8px var(--color-kin-lavender)" }}
            />
            <ScreenLabel style={{ letterSpacing: "0.2em" }}>
              <span style={{ color: "var(--color-kin-lavender)" }}>Latest Insight</span>
            </ScreenLabel>
          </div>
          <DisplayText size={18} color="var(--color-kin-black)">
            Sleep Analysis
          </DisplayText>
          <BodyText
            size={10}
            color="var(--color-kin-muted)"
            weight={500}
            style={{ marginTop: 4, lineHeight: 1.4 }}
          >
            Updated 3h ago · Sleep consistency is the main lever this week.
          </BodyText>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <BodyText
              size={9}
              color="var(--color-kin-lavender)"
              weight={800}
              style={{ letterSpacing: "0.02em" }}
            >
              Recovery trend +15
            </BodyText>
            <div
              style={{
                background: "rgba(165,144,255,0.12)",
                border: "1px solid rgba(165,144,255,0.3)",
                borderRadius: 24,
                padding: "4px 12px",
                transition: "all 0.3s ease",
              }}
            >
              <BodyText size={9} color="var(--color-kin-lavender)" weight={700}>
                Open
              </BodyText>
            </div>
          </div>
        </Glass>
      </div>

      {/* Active Trackers */}
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
            paddingLeft: 4,
            paddingRight: 4,
          }}
        >
          <ScreenLabel style={{ letterSpacing: "0.2em", color: "var(--color-kin-muted)" }}>
            Today's Trackers
          </ScreenLabel>
          <BodyText size={9} color="var(--color-kin-lavender)" weight={700}>
            See logs →
          </BodyText>
        </div>
        <Glass style={{ padding: "4px 14px", borderRadius: 20 }}>
          {trackers.map((t, i) => (
            <div
              key={t.label}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 0",
                borderBottom: i < trackers.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
              }}
            >
              <Dot
                color={t.color}
                size={8}
                style={{ boxShadow: `0 0 6px ${alpha(t.color, "80")}` }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <BodyText size={11} weight={700} color="var(--color-kin-black)">
                  {t.label}
                </BodyText>
                <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                  {t.detail}
                </BodyText>
              </div>
              {t.status.kind === "meta" ? (
                <BodyText size={9} color={t.status.color} weight={800}>
                  {t.status.text}
                </BodyText>
              ) : (
                <div
                  style={{
                    background: alpha(t.color, "15"),
                    border: borderAlpha(t.color, "30"),
                    borderRadius: 20,
                    padding: "3px 10px",
                  }}
                >
                  <BodyText size={8.5} color={t.color} weight={800}>
                    {t.status.text}
                  </BodyText>
                </div>
              )}
            </div>
          ))}
        </Glass>
      </div>

      {/* From Your Data — source entries with extracted facts */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ paddingLeft: 4 }}>
          <ScreenLabel style={{ letterSpacing: "0.2em", color: "var(--color-kin-muted)" }}>
            From Your Data
          </ScreenLabel>
        </div>

        {/* Blood Panel — file with extracted biomarkers */}
        <Glass style={{ padding: "12px 14px", borderRadius: 20 }}>
          {/* Source row */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 9,
                background: alpha("var(--color-kin-green-soft)", "14"),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--color-kin-green-soft)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <BodyText size={11} weight={700} color="var(--color-kin-black)">
                Blood Panel Feb 2026
              </BodyText>
              <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                Lab report · PDF
              </BodyText>
            </div>
            <BodyText
              size={8}
              color="var(--color-kin-muted)"
              weight={500}
              style={{ flexShrink: 0 }}
            >
              2h
            </BodyText>
          </div>
          {/* Extracted facts */}
          <div
            style={{
              marginLeft: 40,
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-rose)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                LDL Cholesterol
              </BodyText>
              <BodyText size={8.5} color="var(--color-kin-rose)" weight={700}>
                148 mg/dL — high
              </BodyText>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-green-soft)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                HDL Cholesterol
              </BodyText>
              <BodyText size={8.5} color="var(--color-kin-green-soft)" weight={600}>
                62 mg/dL
              </BodyText>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-rose)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                Triglycerides
              </BodyText>
              <BodyText size={8.5} color="var(--color-kin-rose)" weight={700}>
                195 mg/dL — high
              </BodyText>
            </div>
            <BodyText
              size={8.5}
              color="var(--color-kin-muted)"
              weight={600}
              style={{ marginTop: 1 }}
            >
              + 5 more markers in range
            </BodyText>
          </div>
        </Glass>

        {/* Voice note — with extracted observations */}
        <Glass style={{ padding: "12px 14px", borderRadius: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 9,
                background: alpha("var(--color-kin-lavender)", "14"),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--color-kin-lavender)"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <rect x="9" y="4.5" width="6" height="11" rx="3" />
                <path d="M6.5 11.5v1a5.5 5.5 0 0 0 11 0v-1" />
                <path d="M12 18v2.5" />
              </svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <BodyText size={11} weight={700} color="var(--color-kin-black)">
                Voice note · 0:23
              </BodyText>
              <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                Transcribed
              </BodyText>
            </div>
            <BodyText
              size={8}
              color="var(--color-kin-muted)"
              weight={500}
              style={{ flexShrink: 0 }}
            >
              3h
            </BodyText>
          </div>
          <div
            style={{
              marginLeft: 40,
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-lavender)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                Left knee pain after running
              </BodyText>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-lavender)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                Physio session helped
              </BodyText>
            </div>
          </div>
        </Glass>

        {/* Text note — with extracted supplement log */}
        <Glass style={{ padding: "12px 14px", borderRadius: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: 9,
                background: alpha("var(--color-kin-gold)", "14"),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--color-kin-gold)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 4h12v16H6z" />
                <path d="M9 8h6" />
                <path d="M9 12h4" />
              </svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <BodyText size={11} weight={700} color="var(--color-kin-black)">
                Supplement note
              </BodyText>
              <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                Text note
              </BodyText>
            </div>
            <BodyText
              size={8}
              color="var(--color-kin-muted)"
              weight={500}
              style={{ flexShrink: 0 }}
            >
              3h
            </BodyText>
          </div>
          <div
            style={{
              marginLeft: 40,
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <Dot color="var(--color-kin-gold)" size={5} />
              <BodyText size={9} weight={600} color="var(--color-kin-black)">
                Vitamin D — 5000 IU
              </BodyText>
            </div>
          </div>
        </Glass>
      </div>

      {/* Quick actions */}
      <div style={{ display: "flex", gap: 10 }}>
        {quickActions.map((action) => (
          <div
            key={action.label}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              flex: 1,
            }}
          >
            <div
              style={{
                width: 52,
                height: 52,
                borderRadius: 18,
                background: "rgba(254,253,251,0.6)",
                border: "1px solid rgba(255,255,255,0.7)",
                boxShadow: "0 4px 12px -4px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.9)",
                backdropFilter: "blur(12px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1)",
              }}
            >
              {action.icon("var(--color-kin-muted)")}
            </div>
            <BodyText
              size={9}
              color="var(--color-kin-muted)"
              weight={700}
              style={{ letterSpacing: "0.02em" }}
            >
              {action.label}
            </BodyText>
          </div>
        ))}
      </div>

      {/* Recent */}
      <div>
        <div style={{ marginBottom: 8, paddingLeft: 4 }}>
          <ScreenLabel style={{ letterSpacing: "0.2em", color: "var(--color-kin-muted)" }}>
            Recent
          </ScreenLabel>
        </div>
        <Glass style={{ padding: "4px 14px", borderRadius: 20 }}>
          {[
            {
              dot: "var(--color-kin-green-soft)",
              title: "Blood panel Feb 2026",
              sub: "Lab report · 5 markers",
            },
            {
              dot: "var(--color-kin-lavender)",
              title: "Oura Sleep Export",
              sub: "Wearable · Feb 28",
            },
            {
              dot: "var(--color-kin-gold)",
              title: "Nutrition Log Feb 27",
              sub: "Note · daily meals",
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "9px 0",
                borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.03)" : "none",
              }}
            >
              <Dot
                color={item.dot}
                size={6}
                style={{ boxShadow: `0 0 6px ${alpha(item.dot, "60")}` }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <BodyText size={11} color="var(--color-kin-black)" weight={600}>
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    {item.title}
                  </span>
                </BodyText>
                <BodyText
                  size={9}
                  color="var(--color-kin-muted)"
                  weight={500}
                  style={{ marginTop: 1 }}
                >
                  {item.sub}
                </BodyText>
              </div>
            </div>
          ))}
        </Glass>
      </div>
    </div>
  );
}
